import { Point } from 'highcharts';

export default function sortPointByX(a: Partial<Point>, b: Partial<Point>) {
  return (a?.x ?? 0) - (b.x ?? 0);
}
